import { CompanyCreate } from "@/features/company/pages/CompanyCreate";
import { FC } from "react";

const CompanyCreatePage: FC = () => {
  return <CompanyCreate />;
};

export default CompanyCreatePage;
